import React from 'react';
import { StyleSheet, Text } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import { CalcScreen, ListRow } from '../../components/shell';
import { C, FONT, SP } from '../../theme/tokens';

type Calc = { title: string; description: string; screen: string };

const CALCS: Calc[] = [
  {
    title: 'Face Velocity & CFM',
    description: 'Face velocity and exhaust CFM across the sash opening',
    screen: 'FumehoodFaceVelocity',
  },
  {
    title: 'Multi-Point Average',
    description: 'Average a grid of face-velocity readings with uniformity check',
    screen: 'FumehoodMultiPointAverage',
  },
  {
    title: 'Face Area',
    description: 'Open face area from sash width and height',
    screen: 'FumehoodFaceArea',
  },
  {
    title: 'Pressure Differential',
    description: 'Room-to-hood ΔP conversion between Pa and in. w.g.',
    screen: 'FumehoodPressureDifferential',
  },
];

export default function FumehoodCalculationsScreen() {
  const nav = useNavigation();
  return (
    <CalcScreen title="Fume Hood Calculations" subtitle="Face velocity, averaging, face area, pressure">
      <Text style={styles.sectionLabel}>Calculations</Text>
      {CALCS.map((c, i) => (
        <ListRow
          key={c.screen}
          index={i}
          label={c.title}
          description={c.description}
          onPress={() => nav.navigate(c.screen as never)}
        />
      ))}
    </CalcScreen>
  );
}

const styles = StyleSheet.create({
  sectionLabel: {
    fontFamily: FONT.sans,
    fontSize: 12,
    color: C.dim,
    textTransform: 'uppercase',
    letterSpacing: 0.6,
    marginBottom: SP.sm,
  },
});
